/*
Akhila 12/21/2022 3075154998 Added select Field Screen
Sohel 12/22/2022 3075154998 selected processor fields API integration
Sohel 12/23/2022 3075154998 selected processor fields prepopulate data
Sohel 12/26/2022 3075154998 fixed selected processor fields deleted Id Issue
Sohel 01/03/2023 2701323910 payload Changes
Sohel 01/04/2022 2698964415 payload Changes
Sohel 01/09/2023 2698964415 pass selected category in table Payload
dilip 01/10/2023 2698964415 Added unsaved popup.
Sohel 01/10/2023 2698964415 Added disable conditions in Fields.
Sohel 01/12/2023 2698964415 Select field payload Changes
Sohel 01/13/2023 2698964415 Field Type Value Changes
Ashraf 01/13/2023 2698964415 fixed toast messages and loaders
Sohel 01/16/2023 2698964415 fixed dataType Issue
Sohel 01/16/2023 2698964415 fixed Fields payload Issue
sai krishna 01/16/2023 2698964415 add code and description ,type
Sohel 01/16/2023 2698959212 added reset button
Sohel 01/17/2023 2698959212 Added Form in fields
Sohel 01/17/2023 2698959212 Added Temp Field in fields
Sohel 01/17/2023 2698959212 Added Function Fields
Sohel 01/18/2023 2698959212 Payload Changes
Sohel 01/18/2023 2698959212 Fixed Redirect Issue
Sohel 01/18/2023 2698964415 UnSaved Changes Fixed Popup issue
Sohel 01/18/2023 2698964415 Fixed UnSaved popup issue
Sohel 01/20/2023 2698964415 changed Payload
Sohel 01/20/2023 2698964415 Added Last Step in Stepper
Sohel 01/20/2023 2698964415 label changes
Sohel 01/23/2023 2698964415 Added Audit Fields
Sohel 01/22/2023 2698964415 pass Record Group Props
Sohel 01/23/2023 2698964415 fixed save button issue
dilip 01/23/2023 2698964415 Added staged fields Map for Data Import.
Sohel 01/24/2023 2698964415 Payload Changes
Sohel 01/24/2023 2789725780 category populate changes
Suresh Peddavoora 01/25/2023 2789725780 Fixed Button Spacing Alignments
Sohel 01/25/2023 2698964415 Payload Changes
Ashraf 01/27/2023 2698964415 disabled audit field map
Ravi 01/27/2023 2698964415 fixed Reset button issue
dilip 01/27/2023 2698964415 Changed Temporary Repo name
Sohel 01/31/2023 2698964415 payload changes
Suresh Peddavoora 01/31/2023 2698964415 Fixed Button Spacing Alignments
Dilip 02/01/2023 2698964415 code and description label changes
Sohel 01/02/2023 2698964415 fixed validation issue
Sohel 01/07/2023 2698964415 changed Audit Fields Conditions
Sohel 02/08/2023 2701335619 Implement Usage Functionality
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Rohini 02/09/2023 2701335619 added classname for the buttons
Sohel 02/13/2023 2701335619 fixed unique field validation issue
Prakash 02/14/2023 2701335619 Reverted New UI Changes
Sohel 02/17 2023 2701335619 Fixed Validation Issue
Sohel 02/17 2023 2701335619 Fixed Validation Issue
Sohel 02/20/2023 2701335619 Function Date Format Changes
suresh peddavoora 02/22/2023 2701335619 New UI changes fixed
Sohel 02/20/2023 2701335619 Function Date Format Changes
Sohel 03/06/2023 2701335619 changed staging repository to DB repository
Sohel 03/17/2023 2698964415 Fixed Action Dropdown data issue
Prakash 03/21/2023 2701335619 Fixed alignments issue.
Dilip 03/21/2023 2701335619 Fixed label changes.
Sohel 03/28/2023 2701335619 processor fields added logic field
Akhila 03/29/2023 2701335619 unsaved changes popup fixed
Prakash 03/29/2023 2701335619 Removed margin spacing.
Akhila 04/10/2023 2701335619 unsaved changes bug fixed
Sohel 04/12/2023 2701335619 Added Logic Fields in Imports
Sohel 04/19/2023 2698964415 Added Data Calculation Field
Prakash 19-04-2023 2701335619 add margin top .
Sohel 04/24/2023 2701335619 Added Summary Fields
 Prakash 24/04/2023 2701335619 fixed button alignment issue for tab view
Akhila 06/12/2023 2701335619 added role access
Ravi 06/15/2023 2701335619 rename map fields title
Sohel 06/19/2023 2701335619 change Temp Repo and Function repository name
Ravi 06/19/2023 2701335619 Added Breadcrum in data cal and map fields
Ravi 06/19/2023 2701335619 Added Breadcrum in popup
Ravi 06/19/2023 2701335619 show code and description conditionally on BreadCrum
Sohel 06/21/2023 2701335619 disabled SAVE button
Ravi 06/23/2023 2701335619 fixed submit issue
Sohel 12/12/2023 2701335619 label name change code to name 
*/
import React, {useState, useEffect, useRef} from 'react';
import {Button} from '@material-ui/core';
import reusableInputStyles from '../../../../../components/InputStyles';
import SearchFields from '../../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import DialogBox from './../../../../../components/DialogBox/index';
import DMRSelectFieldsTable from './DMRSelectFieldsTable';
import {useSelector, useDispatch} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {
  fetchDmFormats,
  fetchSelectedProcessorFieldsData,
  postSelectProcessor,
  resetProcessorFields,
} from '../../../../../redux/reducers/DataManagerRecord';
import {resetBasicInfo} from '../../../../../redux/reducers/DataManagerRecord';
import {resetBasicInfo as resetRecordGroupBasicInfo} from '../../../../../redux/reducers/DataManagerRecordGroup';
import BreadCrums from '../../../../../util/BreadCrum';
import {Field, FieldArray, Form, Formik} from 'formik';
import * as Yup from 'yup';
import AddIcon from '@material-ui/icons/Add';
import {getLookupCode} from './DMRRecordFormatFields';
import {fetchFunctionList} from '../../../../../redux/reducers/lookupReducer';
import SearchAuditFields from './AuditFields';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import SearchLogicField from '../AddDataManagerRecord/SearchLogicField';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
const allowedDuplicate = (current) =>
  current.processorFieldType === 'Function' &&
  (current.processorFieldName || current.fieldName) &&
  ['FIXED_TEXT', 'DATE', 'TIME', 'DATE_TIME', 'CONSTANT'].includes(
    current.processorFieldName || current.fieldName,
  );
const DMRFieldSelect = ({
  handleBack,
  handleNext,
  exportManagerRecord,
  handleDirty,
  processor,
  showAlert,
  emgAuditFields,
  showAlertRef,
  managerRecordGroup = false,
  dmTempRecordAccess,
  exportRecordGroupAccess,
  importRecordGroupAccess,
  editExisting,
}) => {
  const classes = reusableInputStyles();
  const [open, setOpen] = useState(false);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [fieldData, setFieldData] = useState([]);
  const deletedProcessorFields = useRef([]);
  const [auditFieldOpen, setAuditFieldOpen] = useState(false);
  const initialVal = {
    selectedFields: [],
  };
  const [initialValues, setInitialValues] = useState(initialVal);

  const saveRef = useRef();
  const dmrArrayHelpers = useRef();
  const dispatch = useDispatch();
  const [logicFieldsOpen, setLogicFieldsOpen] = useState(false);
  const {functionsList, loading, error} = useSelector(({lookup}) => lookup);
  const {
    isProcessorLoading,
    processorSuccessMsg,
    processorErrorMsg,
    processorStatus,
    recordCode,
    selectedProcessorFields,
    category,
    basicInfoData,
    basicInfoSuccessMsg,
    isBasicInfoLoading,
    isDraftRecord,
    dataManagerRecordId,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    isLoading,
    successMsg,
    errorMsg,
    groupCode,
    isDraftRecordGroup,
    basicInfoData: recordGroupBasicInfoData,
    categoryRecordGroup,
    recordType,
    dmRecordGroupId
  } = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (recordType.value) {
      const lookupCode = getLookupCode(recordType.value);
      if (lookupCode) {
        dispatch(fetchFunctionList(lookupCode));
      }
    }
    dispatch(fetchDmFormats());
  }, [recordType]);
  const handleLogicFieldsClose = () => {
    setLogicFieldsOpen(false);
  };
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  useEffect(() => {
    if (recordGroupBasicInfoData?.groupType) {
      const lookupCode = getLookupCode(recordGroupBasicInfoData?.groupType);
      if (lookupCode) {
        dispatch(fetchFunctionList(lookupCode));
      }
    }
    dispatch(fetchDmFormats());
  }, [recordGroupBasicInfoData?.groupType]);
  useEffect(() => {
    if (basicInfoSuccessMsg) {
      setTimeout(() => {
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoSuccessMsg]);
  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetRecordGroupBasicInfo());
      }, 1500);
    }
  }, [errorMsg, successMsg]);
  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Field Type',
    },
    {
      title: 'Repository Name',
    },
    {
      title: 'Field Name',
    },
    {
      title: 'Value',
    },
    {
      title: 'Data Type',
    },
  ];
  const handleClose = () => {
    setOpen(false);
    setAuditFieldOpen(false);
  };
  const type = exportManagerRecord ? 'Export' : 'Import';
  const validationSchema = Yup.object().shape({
    selectedFields: Yup.array().of(
      Yup.object().shape({
        processorFieldName: Yup.mixed()
          .test('FieldName', 'Field Name is required', (value, ctx) => {
            if (
              !value &&
              ['Temp Field', 'Summary Field', 'Function']?.includes(ctx.parent.processorFieldType)
            ) {
              return false;
            } else {
              return true;
            }
          })
          .test(
            'duplicate check',
            (path) => {
              return `Field name ${path.value} is already defined`;
            },
            (value, context) => {
              const form = context.from[1] || [];
              const noDuplicateValidation = allowedDuplicate(context.parent);
              const tempFieldNames = form?.value?.selectedFields.filter((el) => {
                return (
                  el.processorFieldType !== 'DB Field' &&
                  el.processorFieldType !== 'Audit Field' &&
                  el.processorFieldType !== 'Data Calculation Field' &&
                  context.originalValue === value &&
                  el?.processorFieldType === context?.parent?.processorFieldType &&
                  value &&
                  (el.processorFieldName === value || el.fieldName === value) &&
                  !noDuplicateValidation
                );
              });
              if (value && tempFieldNames.length > 1) {
                return false;
              } else {
                return true;
              }
            },
          ),
        fieldValue: Yup.mixed().test('FieldValue', 'Value is required', (value, ctx) => {
          const validate =
            ctx.parent.processorFieldType === 'Function' &&
            ctx.parent.processorFieldName &&
            ['FIXED_TEXT', 'TIME', 'DATE_TIME'].includes(ctx.parent.processorFieldName);
          if (!value && ctx.parent.processorFieldType === 'Function' && validate) {
            return false;
          } else {
            return true;
          }
        }),
      }),
    ),
  });
  const onSubmit = (values) => {
    if (recordCode && !managerRecordGroup) {
      dispatch(submissionStart());
      const selectedProcessorFields =
        values?.selectedFields?.length > 0 ?
          values?.selectedFields?.map((el) => {
            return {
              category: el?.category,
              fieldName: ['Temp Field', 'Summary Field', 'Function']?.includes(
                el?.processorFieldType,
              ) ?
                el?.processorFieldName :
                el?.fieldName,
              fieldType:
                  el?.tabType === 'Record Format Field' ? el?.fieldType : el?.processorFieldType,
              recordCode: recordCode,
              recordFieldMapId: el?.processorId ? el?.processorId : 0,
              repositoryName: el?.repositoryName,
              tabType: el?.tabType ? el?.tabType : 'Processor Field',
              // fieldValue: el?.processorFieldType === "Function" ? el?.fieldValue : "",
              fieldValue:
                  el?.processorFieldType === 'Function' && el?.processorFieldName === 'DATE' ?
                    el.fieldValue ?
                      el.dateType + el.fieldValue :
                      'T' :
                    el.fieldValue ?
                      el.fieldValue :
                      '',
              dataRepoId: el?.dataRepositoryId ? el?.dataRepositoryId : el?.dataRepoId ? el?.dataRepoId : 0,
              dataRepoFieldId: el?.repositoryFieldId ? el?.repositoryFieldId : el?.dataRepoFieldId ? el?.dataRepoFieldId : 0,
              dataType:
                  el?.processorFieldType === 'Function' ?
                    functionsList?.filter((e) => e.value === el.processorFieldName)[0]
                      ?.dataType || '' :
                    el?.dataType ?
                      el?.dataType :
                      '',
            };
          }) :
          [];
      const payload = {
        deleteDmRecordFieldMapIds: [...new Set(deletedProcessorFields.current)],
        dmRecordSelectFieldsRequest: selectedProcessorFields,
        recordCode: recordCode,
        fileType: type,
        dataManagerRecordId: dataManagerRecordId ? dataManagerRecordId : 0,
        lastStep: isDraftRecord === 'N' ? basicInfoData?.lastStep : saveRef.current ? 2 : 3,
      };
      dispatch(postSelectProcessor(payload, managerRecordGroup));
    } else if (managerRecordGroup && groupCode) {
      dispatch(submissionStart());
      const selectedProcessorFields =
        values?.selectedFields?.length > 0 ?
          values?.selectedFields?.map((el) => {
            return {
              category: el?.category,
              fieldName: ['Temp Field', 'Summary Field', 'Function']?.includes(
                el?.processorFieldType,
              )
                ? el?.processorFieldName
                : el?.fieldName,
              fieldType:
                el?.tabType === 'Record Format Field' ? el?.fieldType : el?.processorFieldType,
              recordGroupCode: groupCode,
              recordGroupFieldMapId: el?.processorId ? el?.processorId : 0,
              repositoryName: el?.repositoryName,
              tabType: el?.tabType ? el?.tabType : 'Processor Field',
              // fieldValue: el?.processorFieldType === "Function" && el.processorFieldName === "DATE" ? "TODAY" : el?.processorFieldType === "Function" &&
              // el?.fieldValue ? el.fieldValue: "",
              fieldValue:
                el?.processorFieldType === 'Function' && el?.processorFieldName === 'DATE'
                  ? el.fieldValue
                    ? el.dateType + el.fieldValue
                    : 'T'
                  : el.fieldValue
                    ? el.fieldValue
                    : '',
              dataType:
                el?.processorFieldType === 'Function'
                  ? functionsList?.filter((e) => e.value === el.processorFieldName)[0]?.dataType ||
                    ''
                  : el?.dataType
                    ? el?.dataType
                    : '',
              dataRepoId: el?.dataRepositoryId ? el?.dataRepositoryId : el?.dataRepoId ? el?.dataRepoId : 0,
              dataRepoFieldId: el?.repositoryFieldId ? el?.repositoryFieldId : el?.dataRepoFieldId ? el?.dataRepoFieldId : 0,
            };
          }) :
          [];
      const payload = {
        deleteDmRecordGroupFieldMapIds: [...new Set(deletedProcessorFields.current)],
        dmRecordGroupSelectFieldsRequest: selectedProcessorFields,
        recordGroupCode: groupCode,
        recordGroupId: dmRecordGroupId ? dmRecordGroupId : 0,
        fileType: type,
        lastStep:
          isDraftRecordGroup === 'N' ? recordGroupBasicInfoData?.lastStep : saveRef.current ? 2 : 3,
      };
      dispatch(postSelectProcessor(payload, managerRecordGroup));
    }
  };

  useEffect(() => {
    if (processorErrorMsg || processorSuccessMsg) {
      setTimeout(() => {
        if (processorStatus === 200 && processorSuccessMsg && !saveRef.current) {
          handleNext && handleNext();
        }
        dispatch(resetProcessorFields());
      }, 1500);
    }
  }, [processorErrorMsg, processorSuccessMsg]);

  useEffect(() => {
    if (processorStatus === 200 && processorSuccessMsg) {
      if (dataManagerRecordId && !managerRecordGroup) {
        dispatch(fetchSelectedProcessorFieldsData(type, dataManagerRecordId, managerRecordGroup));
      } else if (dmRecordGroupId && managerRecordGroup) {
        dispatch(fetchSelectedProcessorFieldsData(type, dmRecordGroupId, managerRecordGroup));
      }
    }
  }, [processorStatus, processorSuccessMsg]);
  useEffect(() => {
    if (dataManagerRecordId && !managerRecordGroup) {
      dispatch(fetchSelectedProcessorFieldsData(type, dataManagerRecordId, managerRecordGroup));
    }
  }, [dataManagerRecordId]);
  useEffect(() => {
    if (dmRecordGroupId && managerRecordGroup) {
      dispatch(fetchSelectedProcessorFieldsData(type, dmRecordGroupId, managerRecordGroup));
    }
  }, [dmRecordGroupId]);
  useEffect(() => {
    if (selectedProcessorFields?.length > 0) {
      const fields = selectedProcessorFields?.map((el) => {
        return {
          dataRepoFieldId:el?.dataRepoFieldId ? el.dataRepoFieldId:0,
          dataRepoId:el?.dataRepoId ? el?.dataRepoId : 0,
          category: el?.category,
          fieldName:
            el?.tabType !== 'Record Format Field' &&
            ['Temp Field', 'Function', 'Summary Field']?.includes(el?.fieldType) ?
              '' :
              el?.fieldName,
          fieldType: el?.fieldType,
          isActive: el?.isActive,
          recordCode: recordCode,
          recordFieldMapId: el?.recordFieldMapId ? el?.recordFieldMapId : 0,
          repositoryName: el?.repositoryName,
          tabType: el?.tabType ? el?.tabType : '',
          processorId: el?.processorId ? el?.processorId : 0,
          isEditable: el?.isEditable ? el?.isEditable : '',
          dataType: el?.dataType ? el?.dataType : '',
          // fieldValue: el?.fieldValue ? el?.fieldValue : "",
          processorFieldType: el?.fieldType, // el?.tabType !== "Record Format Field" ? el?.fieldType : "",
          processorFieldName: el?.fieldName,
          // el?.tabType !== "Record Format Field" &&
          // ["Temp Field", "Function"]?.includes(el?.fieldType)
          //   ? el?.fieldName
          //   : "",
          fieldValue:
            el?.tabType !== 'Record Format Field' &&
            el?.fieldType === 'Function' &&
            el?.fieldName === 'DATE' ?
              el.fieldValue?.replace(/\D/g, '') :
              el.fieldValue ?
                el.fieldValue :
                '',
          dateType:
            el?.tabType !== 'Record Format Field' &&
            el?.fieldType === 'Function' &&
            el?.fieldName === 'DATE' ?
              el?.fieldValue === 'T' ?
                'T + ' :
                el?.fieldValue?.replace(/[0-9]/g, '') :
              '',
        };
      });
      setInitialValues({...initialValues, selectedFields: fields});
      setFieldData(fields);
    }
  }, [selectedProcessorFields]);

  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(values) => onSubmit(values)}
        validationSchema={validationSchema}
      >
        {(props) => {
          const {values, setFieldValue, submitForm, dirty} = props;
          if (processor && dirty) {
            // showAlert.current = dirty;
            // showAlertRef.current = dirty;
            handleDirty(true);
          }

          handleDirty && handleDirty(dirty);
          return (
            <>
              <Form noValidate>
                <FieldArray
                  name="selectedFields"
                  render={(arrayHelpers) => {
                    dmrArrayHelpers.current = arrayHelpers;
                    return (
                      <>
                        <div>
                          <BreadCrums
                            name={
                              managerRecordGroup && exportManagerRecord
                                ? 'Export Record Group Name'
                                : managerRecordGroup && !exportManagerRecord
                                  ? 'Import Record Group Name'
                                  : !managerRecordGroup && exportManagerRecord
                                    ? 'Export Template Record Name'
                                    : 'Import Template Record Name'
                            }
                            code={
                              managerRecordGroup
                                ? recordGroupBasicInfoData?.groupCode
                                : basicInfoData?.recordCode
                            }
                            description={
                              !managerRecordGroup && exportManagerRecord
                                ? 'Export Template Record Description'
                                : managerRecordGroup
                                  ? `${type} Record Group Description`
                                  : 'Import Template Record Description'
                            }
                            descriptionValue={
                              managerRecordGroup
                                ? recordGroupBasicInfoData?.groupDescription
                                : basicInfoData?.recordDescription
                            }
                            returnType={'Type'}
                            returnTypeValue={
                              managerRecordGroup
                                ? recordGroupBasicInfoData?.groupType
                                : basicInfoData?.recordType || ''
                            }
                          />
                        </div>
                        <div
                          className={
                            exportManagerRecord
                              ? 'table-header justify-content-end new-standard-textfields exporttemplate-buttons'
                              : 'table-header justify-content-end new-standard-textfields'
                          }
                        >
                          {exportManagerRecord ||
                          ['Data Update', 'New Account Import']?.includes(recordType?.value) ? (
                              <Button
                                variant="outlined"
                                className={`search-btn mx-1 ${classes.buttonRoot}`}
                                onClick={() => setLogicFieldsOpen(true)}
                                startIcon={<AddIcon />}
                              >
                              Data Calculations Fields
                              </Button>
                            ) : null}

                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => setOpen(true)}
                            startIcon={<AccountTreeIcon />}
                          >
                            Map Fields
                          </Button>
                          {['Data Export']?.includes(recordType?.value) ? (
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                const summaryFields = {
                                  processorFieldType: 'Summary Field',
                                  repositoryName: 'SUMMARY_REPO',
                                  fieldName: '',
                                  value: '',
                                  dataType: 'Text',
                                  fieldValue: '',
                                  processorFieldName: '',
                                };
                                arrayHelpers.push(summaryFields);
                              }}
                              startIcon={<AddIcon />}
                            >
                              Summary Fields
                            </Button>
                          ) : null}
                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              const tempFields = {
                                processorFieldType: 'Temp Field',
                                repositoryName: 'TEMPORARY_REPO',
                                fieldName: '',
                                value: '',
                                dataType: 'Text',
                                fieldValue: '',
                                processorFieldName: '',
                              };
                              arrayHelpers.push(tempFields);
                            }}
                          >
                            <AddIcon />
                            Temp Field
                          </Button>
                          <Button
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              const functionFields = {
                                repositoryName: 'FUNCTION',
                                fieldName: '',
                                processorFieldName: '',
                                value: '',
                                processorFieldType: 'Function',
                                dataType: '',
                                fieldValue: '',
                                dateType: 'T + ',
                              };
                              arrayHelpers.push(functionFields);
                            }}
                          >
                            <AddIcon />
                            Function
                          </Button>
                          {((exportManagerRecord && basicInfoData?.includeAudit === 'Y') ||
                            (exportManagerRecord &&
                              emgAuditFields &&
                              emgAuditFields === 'Group' &&
                              recordGroupBasicInfoData?.includeAudit === 'Y')) && (
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => setAuditFieldOpen(true)}
                              startIcon={<AddIcon />}
                            >
                              Audit Fields
                            </Button>
                          )}
                        </div>
                        <div
                          className={
                            'mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields '
                          }
                        >
                          <table>
                            <thead className="recFormat-header-container">
                              <tr>
                                {columns.map(
                                  ({ title, hidden = false }) =>
                                    !hidden && (
                                      <th key={title} className="recFormat-header">
                                        {title}
                                      </th>
                                    ),
                                )}
                              </tr>
                            </thead>
                            {values.selectedFields?.length > 0 ? (
                              <tbody className="recFormat-body">
                                {values.selectedFields.map((field, index) => (
                                  <>
                                    <Field
                                      key={field.fieldName + field.repositoryName}
                                      name={`selectedFields[${index}]`}
                                      component={DMRSelectFieldsTable}
                                      index={index}
                                      columns={columns}
                                      dmArrayHelpers={dmrArrayHelpers}
                                      deletedProcessorFields={deletedProcessorFields}
                                      functionsList={functionsList || []}
                                      editExisting={editExisting}
                                      dmTempRecordAccess={dmTempRecordAccess}
                                      exportRecordGroupAccess={exportRecordGroupAccess}
                                      importRecordGroupAccess={importRecordGroupAccess}
                                    />
                                  </>
                                ))}
                              </tbody>
                            ) : (
                              <tbody>
                                <tr>
                                  <td colSpan={columns.length}>
                                    No records to display. To add fields to your report click the
                                    &quot;Map Fields&quot; button in the top right of this section.
                                  </td>
                                </tr>
                              </tbody>
                            )}
                          </table>
                        </div>
                        <DialogBox
                          open={open}
                          dialogClose={handleClose}
                          title={
                            <div className="dialog-breadcrum">
                              <p className="dialoge-title-breadcrum">
                                <b>Map Fields</b>
                              </p>
                              <BreadCrums
                                name={
                                  managerRecordGroup && exportManagerRecord
                                    ? 'Export Record Group Name'
                                    : managerRecordGroup && !exportManagerRecord
                                      ? 'Import Record Group Name'
                                      : !managerRecordGroup && exportManagerRecord
                                        ? 'Export Template Record Name'
                                        : 'Import Template Record Name'
                                }
                                code={
                                  managerRecordGroup
                                    ? recordGroupBasicInfoData?.groupCode
                                    : basicInfoData?.recordCode
                                }
                                description={
                                  !managerRecordGroup && exportManagerRecord
                                    ? 'Export Template Record Description'
                                    : managerRecordGroup
                                      ? `${type} Record Group Description`
                                      : 'Import Template Record Description'
                                }
                                descriptionValue={
                                  managerRecordGroup
                                    ? recordGroupBasicInfoData?.groupDescription
                                    : basicInfoData?.recordDescription
                                }
                              />
                            </div>
                          }
                          maxWidth="xl"
                        >
                          {/* {isNewBusinessRecords ? (
                            <SearchIntermediateRepo
                              isProcessorFieldsMap={true}
                              mapFields={true}
                              isDataManager={true}
                              tempSelectedRows={tempSelectedRows}
                              handleDialogClose={handleClose}
                              setTempSelectedRows={setTempSelectedRows}
                              setDMFieldValue={setFieldValue}
                              dmValues={values}
                              recordType={recordType}
                            />
                          ) : ( */}
                          <SearchFields
                            setDMFieldValue={setFieldValue}
                            dmValues={values}
                            setTempSelectedRows={setTempSelectedRows}
                            tempSelectedRows={tempSelectedRows}
                            isReports={true}
                            mapFields={true}
                            isDMRTrue={true}
                            moduleName={exportManagerRecord ? 'EXPORT' : 'IMPORT'}
                            handleClose={handleClose}
                            deletedProcessorFields={deletedProcessorFields}
                            dmRecordCategory={managerRecordGroup ? categoryRecordGroup : category}
                          />
                          {/* )} */}
                        </DialogBox>
                        <DialogBox
                          open={auditFieldOpen}
                          dialogClose={handleClose}
                          // title="Search Audit Fields"
                          title={
                            <div className="dialog-breadcrum">
                              <p className="dialoge-title-breadcrum">
                                <b>Search Audit Fields</b>
                              </p>
                              <BreadCrums
                                name={
                                  managerRecordGroup
                                    ? 'Export Record Group Name'
                                    : 'Export Template Record Name'
                                }
                                code={
                                  managerRecordGroup
                                    ? recordGroupBasicInfoData?.groupCode
                                    : basicInfoData?.recordCode
                                }
                                description={
                                  !managerRecordGroup
                                    ? 'Export Template Record Description'
                                    : `Export Record Group Description`
                                }
                                descriptionValue={
                                  managerRecordGroup
                                    ? recordGroupBasicInfoData?.groupDescription
                                    : basicInfoData?.recordDescription
                                }
                              />
                            </div>
                          }
                          maxWidth="xl"
                        >
                          <SearchAuditFields
                            setAuditFieldValue={setFieldValue}
                            dmValues={values}
                            setTempSelectedRows={setTempSelectedRows}
                            tempSelectedRows={tempSelectedRows}
                            handleClose={handleClose}
                            deletedProcessorFields={deletedProcessorFields}
                            dmRecordCategory={managerRecordGroup ? categoryRecordGroup : category}
                          />
                        </DialogBox>
                        <DialogBox
                          open={logicFieldsOpen}
                          dialogClose={handleLogicFieldsClose}
                          // title="Search Data Calculations Fields"
                          title={
                            <div className="dialog-breadcrum">
                              <p className="dialoge-title-breadcrum">
                                <b>Search Data Calculations Fields</b>
                              </p>
                              <BreadCrums
                                name={
                                  managerRecordGroup && exportManagerRecord
                                    ? 'Export Record Group Name'
                                    : managerRecordGroup && !exportManagerRecord
                                      ? 'Import Record Group Name'
                                      : !managerRecordGroup && exportManagerRecord
                                        ? 'Export Template Record Name'
                                        : 'Import Template Record Name'
                                }
                                code={
                                  managerRecordGroup
                                    ? recordGroupBasicInfoData?.groupCode
                                    : basicInfoData?.recordCode
                                }
                                description={
                                  !managerRecordGroup && exportManagerRecord
                                    ? 'Export Template Record Description'
                                    : managerRecordGroup
                                      ? `${type} Record Group Description`
                                      : 'Import Template Record Description'
                                }
                                descriptionValue={
                                  managerRecordGroup
                                    ? recordGroupBasicInfoData?.groupDescription
                                    : basicInfoData?.recordDescription
                                }
                              />
                            </div>
                          }
                          maxWidth="xl"
                        >
                          <SearchLogicField
                            setAuditFieldValue={setFieldValue}
                            dmValues={values}
                            setTempSelectedRows={setTempSelectedRows}
                            tempSelectedRows={tempSelectedRows}
                            handleClose={handleLogicFieldsClose}
                            dmRecordCategory={category}
                            deletedProcessorFields={deletedProcessorFields}
                            isRecordFormat={false}
                          />
                        </DialogBox>
                      </>
                    );
                  }}
                />

                <div className="d-flex justify-content-center new-standard-textfields mt-3">
                  {handleBack && (
                    <Button
                      variant="outlined"
                      onClick={() => {
                        handleBack();
                      }}
                      className={`reset-btn mr-1 ${classes.buttonRoot}`}
                    >
                      Back
                    </Button>
                  )}
                  {!processor && ( // (isDraftRecord === "N" || isDraftRecordGroup === "N")
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                      disabled={
                        (editExisting === 'Import' && !dmTempRecordAccess?.edit) ||
                        (editExisting === 'Export' && !dmTempRecordAccess?.edit) ||
                        (editExisting === 'Export Record Group' &&
                          !exportRecordGroupAccess?.edit) ||
                        (editExisting === 'Import Record Group' && !importRecordGroupAccess?.edit)|| isProcessorLoading||processorSuccessMsg||processorErrorMsg || 
                        enabledSubmission
                      }
                      onClick={() => {
                        saveRef.current = true;
                        handleDirty(false, 'fixed');
                        submitForm(values);
                      }}
                    >
                      Save
                    </Button>
                  )}
                  {handleNext ? (
                    <Button
                      variant="outlined"
                      type="submit"
                      disabled={
                        (editExisting === 'Import' && !dmTempRecordAccess?.edit) ||
                        (editExisting === 'Export' && !dmTempRecordAccess?.edit) ||
                        (editExisting === 'Export Record Group' &&
                          !exportRecordGroupAccess?.edit) ||
                        (editExisting === 'Import Record Group' && !importRecordGroupAccess?.edit) ||isProcessorLoading||processorSuccessMsg||processorErrorMsg || 
                        enabledSubmission
                      }
                      onClick={() => {
                        saveRef.current = false;
                      }}
                      className={`search-btn ml-1 ${classes.buttonRoot}`}
                    >
                      Save & Next
                    </Button>
                  ) : (
                    processor && (
                      <div>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            // setInitialValues({
                            //   ...initialValues,
                            //   selectedFields: fieldData?.length > 0 ? fieldData : [],
                            // });
                            setFieldValue('selectedFields', fieldData);
                          }}
                          className={`reset-btn mr-1 ${classes.buttonRoot}`}
                        >
                          Reset
                        </Button>
                        <Button
                          variant="outlined"
                          disabled={
                            (editExisting === 'Import' && !dmTempRecordAccess?.edit) ||
                            (editExisting === 'Export' && !dmTempRecordAccess?.edit) ||
                            (editExisting === 'Export Record Group' &&
                              !exportRecordGroupAccess?.edit) ||
                            (editExisting === 'Import Record Group' &&
                              !importRecordGroupAccess?.edit) ||isProcessorLoading||processorSuccessMsg||processorErrorMsg || enabledSubmission
                          }
                          onClick={() => {
                            saveRef.current = false;
                            handleDirty(false, 'fixed');
                            submitForm(values);
                          }}
                          className={`search-btn ml-1 ${classes.buttonRoot}`}
                        >
                          Save
                        </Button>
                      </div>
                    )
                  )}
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {(isProcessorLoading ||
        isBasicInfoLoading ||
        loading ||
        isLoading ||
        printUsageIsLoading) && <PageLoader />}
      {(processorErrorMsg || error || errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={processorErrorMsg || error || errorMsg || printUsageErrorMsg} />
      )}
      {(processorSuccessMsg || basicInfoSuccessMsg || successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={
            basicInfoSuccessMsg || processorSuccessMsg || successMsg || printUsageSuccessMsg
          }
        />
      )}
    </>
  );
};

export default DMRFieldSelect;
